import { useRef, memo } from 'react';
import { useCalendarCell } from 'react-aria';
import { CalendarState } from '@react-stately/calendar';
import type { AriaCalendarCellProps } from 'react-aria';



export interface CalendarCellProps extends AriaCalendarCellProps {
	state: CalendarState,
}


const CalendarCell = (props: CalendarCellProps) => {
	const { state, ...otherProps } = props;
	
	const ref = useRef<HTMLDivElement>(null);
	let { cellProps, buttonProps, isSelected, isOutsideVisibleRange, isDisabled, isUnavailable, formattedDate } = useCalendarCell(otherProps, state, ref);

	return (
		<td {...cellProps}>
			<div {...buttonProps} ref={ref} hidden={isOutsideVisibleRange}
				className={`cell ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''} ${isUnavailable ? 'unavailable' : ''}`}>
				
				{formattedDate}
			</div>
		</td>
	)
}

export default memo(CalendarCell);